import { render, staticRenderFns } from "./neibu.vue?vue&type=template&id=1faabe14&scoped=true&"
import script from "./neibu.vue?vue&type=script&lang=js&"
export * from "./neibu.vue?vue&type=script&lang=js&"
import style0 from "./neibu.vue?vue&type=style&index=0&id=1faabe14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faabe14",
  null
  
)

export default component.exports